import React, { Component, useEffect } from 'react';
import { TweenMax } from "gsap";
import Icon from './Icon';
import { store } from '../components/_App/redux';

class Cursor extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			type: 'normal',
			moved: false
		};

		const unsubscribe = store.subscribe(() => {
			setTimeout(() => {
				this.setListners();
			}, 100);
		});
	}

	$bigBall;
	$smallBall;
	$hoverables;
	
	componentDidMount() {
		this.setListners();
	}

	UNSAFE_componentWillReceiveProps() {
		this.setListners();
	}

	setListners() {
		this.setState({ type: 'normal' });
		this.$bigBall = document.getElementById('cursor-circle');
		this.$smallBall = document.getElementById('cursor-ball');
		this.$hoverables = document.querySelectorAll('.link, .button, .hoverable');
		this.$hoverClose = document.querySelectorAll('.cursor-close');

		console.log(this.$hoverClose);

		// Listeners
		document.body.addEventListener('mousemove', this.onMouseMove);
		for (let i = 0; i < this.$hoverables.length; i++) {
			this.$hoverables[i].addEventListener('mousemove', this.onMouseHover);
			this.$hoverables[i].addEventListener('mouseleave', this.onMouseHoverOut);
		}
		for (let i = 0; i < this.$hoverClose.length; i++) {
			console.log('hoverClose');
			this.$hoverClose[i].addEventListener('mousemove', this.onMouseCloseHover);
			this.$hoverClose[i].addEventListener('mouseleave', this.onMouseCloseHoverOut);
		}
	}
	
	// Move the cursor
	onMouseMove = (e) => {
	this.setState({ moved: true });
	  TweenMax.to(this.$bigBall, .4, {
		x: e.clientX - 30,
		y: e.clientY - 32
	  })
	  TweenMax.to(this.$smallBall, .1, {
		x: e.clientX - 7,
		y: e.clientY - 9
	  })
	};
	
	// Hover an element
	onMouseHover = (e) => {
	  TweenMax.to(this.$bigBall, .3, {
		scale: 2
	  })
	};

	onMouseHoverOut = (e) => {
	  TweenMax.to(this.$bigBall, .3, {
		scale: 1
	  })
	};	

	// Hover Close an element
	onMouseCloseHover = (e) => {
		TweenMax.to(this.$bigBall, .3, {
		  scale: 2
		})
		this.setState({ type: 'close' });
	};

	onMouseCloseHoverOut = (e) => {
		TweenMax.to(this.$bigBall, .3, {
		  scale: 1
		})
		this.setState({ type: 'normal' });
	};

	render() {
		let cursorClass = [ 'cursor' ];
		if (this.state.type === 'close') {
			cursorClass.push('is-close');
		}
		if (this.state.type === 'prev') {
			cursorClass.push('is-prev');
		}
		if (this.state.type === 'next') {
			cursorClass.push('is-next');
		}
		if (this.state.moved) {
			cursorClass.push('is-moved');
		}

		return (
			<div className={cursorClass.join(' ')}>
				<div className="cursor__ball cursor__ball--big " id="cursor-circle">
					<svg height="60" width="60">
						<circle cx="30" cy="30" r="24" strokeWidth="0"></circle>
					</svg>
				</div>
				
				<div className="cursor__ball cursor__ball--small" id="cursor-ball">
					<svg className="cursor-normal" height="15" width="15"><circle cx="7.5" cy="7.5" r="6" strokeWidth="0"></circle></svg>
					<Icon className="icon-prev" name="back" title="Prev icon" />
					<Icon className="icon-next" name="next" title="Next icon" />
					<Icon className="icon-close" name="close" title="Close icon" />
				</div>
			</div>
		);

	}
}

export default Cursor;
